// The seven chains Willow RPC serves, in the order the docs list them.
// One key works on every chain; the chain ID is part of the URL.

export interface RpcChain {
  id: number;
  name: string;
}

export const RPC_CHAINS: RpcChain[] = [
  { id: 1, name: 'Ethereum' },
  { id: 8453, name: 'Base' },
  { id: 42161, name: 'Arbitrum One' },
  { id: 10, name: 'OP Mainnet' },
  { id: 130, name: 'Unichain' },
  { id: 57073, name: 'Ink' },
  { id: 4663, name: 'Robinhood Chain' },
];

export const RPC_BASE_URL = 'https://api.willow.tech/v1/rpc';
export const DOCS_URL = 'https://docs.willow.tech';
export const VERIFY_URL = 'https://api.willow.tech/verify/';

/** Placeholder shown wherever the full key isn't known (keys are shown once). */
export const KEY_PLACEHOLDER = 'YOUR_KEY';

export function chainName(id: number | string): string {
  const n = typeof id === 'string' ? Number(id) : id;
  return RPC_CHAINS.find((c) => c.id === n)?.name ?? `Chain ${id}`;
}

/** The RPC URL for a chain, with the key in the path, or without it for header auth. */
export function rpcUrl(chainId: number, key?: string | null): string {
  return key ? `${RPC_BASE_URL}/${chainId}/${key}` : `${RPC_BASE_URL}/${chainId}`;
}
